import * as Sentry from "@sentry/react";


const isErrorObject = (obj) => obj && obj.stack && obj.message
const tryToSafelyStringify = (obj) => {
    try {
        return JSON.stringify(obj)
    } catch (e) {
        console.log(e);
    }
}

export const ErrorService = {
    handleError(e, hint) {
        try {
            /* Report to Sentry */
            Sentry.captureException(e, hint)
        } catch (veryBadError) {
            console.error(veryBadError);
        }
    }
}